<template>
    <DataTable
        title="Owners"
        :headers="Owner.headers()"
        :model-class="Owner"
        :items="page.props.data"
        :crud-config="{
            createDialogBtnText: 'Create Owner',
            updateDialogBtnText: 'Update Owner',
            deleteDialogBtnText: 'Delete Owner',
            showCustomAction: false,
            customDialogBtnText: 'Add Selected',
            customDialogTitle: 'Add to Payout Event',
            customDialogBtnIcon: 'mdi-cash-plus',
            customDialogBtnDisabled: (item: Owner) => Owner.create(item).is_eligible_for_payout_event,
        }"
        :config="useConfig().owner"
    >
        <template #create-action-dialog="{ item }">
            <CreateOwnerDialog :item />
        </template>
        <template #update-action-dialog="{ item }">
            <UpdateOwnerDialog :item />
        </template>
        <template #delete-action-dialog="{ item }">
            <DeleteOwnerDialog :item />
        </template>
        <template #custom-action-dialog="{ item }">
            <AddToPEDialog :owner-id="item.id" />
        </template>
    </DataTable>
</template>

<script setup lang="ts">
import { Owner } from '@app/land-hold/owner/models/Owner';
import { useConfig } from '@shared/composables/useConfig';
import AddToPEDialog from '@app/land-hold/owner/components/molecules/AddToPEDialog.vue';

const page = Owner.routes().index.page;
</script>
